export default __webpack_public_path__ + "static/media/shopping-cart.inline.8310a000.svg";